import clsx from "clsx";
import React from "react";
import "./styles.scss";

interface ListItemProps {
  children: JSX.Element;
  isShorter?: boolean;
}

export const ListItem = (props: ListItemProps): JSX.Element => {
  const { children, isShorter } = props;
  return (
    <div className="li">
      <div className="li-icon">
        <div className={clsx("li-icon-line", isShorter && "shorter")} />
        <div className="li-icon-point">
          <div />
        </div>
      </div>
      {children}
    </div>
  );
};
ListItem.defaultProps = {
  isShorter: false,
};
